function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  width: 512,
  height: 512,
  rx: "15%",
  fill: "#f80"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 145,
  cy: 367,
  r: 35,
  fill: "#fff"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  stroke: "#fff",
  strokeWidth: 60,
  d: "M109 241c89 0 162 73 162 162M109 127c152 0 276 124 276 276"
});

function SvgRss(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "aria-label": "RSS",
    role: "img",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRss);
export default __webpack_public_path__ + "static/media/rss.dfbc507b.svg";
export { ForwardRef as ReactComponent };